// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".copy-section{padding:3rem 0}@media (min-width:1024px){.copy-section{padding:3vw 0}}.copy-section blockquote,.copy-section blockquote p{font-family:\"minerva-modern\",serif;font-size:30px;line-height:36px;letter-spacing:-.86px;text-align:center}.copy-section h1.special,.copy-section h2.special,.copy-section h3.special,.copy-section h4.special,.copy-section h5.special{font-size:2.5rem;line-height:36px}", ""]);
// Exports
module.exports = exports;
